import { render, staticRenderFns } from "./ProductSearchHeader.vue?vue&type=template&id=31a00b90&scoped=true&"
import script from "./ProductSearchHeader.vue?vue&type=script&lang=ts&"
export * from "./ProductSearchHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSearchHeader.vue?vue&type=style&index=0&id=31a00b90&scoped=true&lang=css&"
import style1 from "./ProductSearchHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a00b90",
  null
  
)

export default component.exports